import analytics from "../common/analytics/analytics";
import { ISearchPushable } from "../common/analytics/analytics.types";
import changeToAnalyticsFormat from "./changeToAnalyticsFormat";
import getFilterAnalytics, {
  getAnalyticsAttribute,
} from "./getFilterAnalytics";
import { date } from "../utils/date";
import { changeToAnalyticsFormatDots } from "../utils/analyticsFormatting";

const defaultValues = {
  mileage: "0..9000000",
  capClean: "0..9000000",
  age: "0MONTH..99YEAR",
};

const rangeFilters = ["Mileage", "CapCleanPrice", "DateRegistered"];

const sortValue = {
  Vehicle: "make",
  SaleDate: "sale-date",
  AuctionCenter: "auction-centre",
  MostRecentlyAdded: "recently-added",
  MileageAscending: "mileage-low",
  MileageDescending: "mileage-high",
  DateRegisteredDescending: "vehicle-age-new",
  DateRegisteredAscending: "vehicle-age-old",
  CAPCleanAscending: "cap-clean-low",
  CAPCleanDescending: "cap-clean-high",
  LotNumber: "lot-number",
};

const pushFilterAnalytics = (
  allAppliedFilters,
  keyword?,
  page?,
  sortBy?,
  totalPages?,
  totalResults?,
  removedFilter?
) => {
  
  const lastAppliedFilter = getFilterAnalytics(
    allAppliedFilters,
    removedFilter
  );
  const previousFilters = allAppliedFilters.slice(0, allAppliedFilters.length);

  let search = {
    batteryReport: "",
    filter: "",
    keyword: "",
    narrative: "",
    searchType: "",
    numResults: "",
    vehicleType: "",
    make: "",
    model: "",
    modelGroup: "",
    derivative: "",
    saleDate: "",
    auctionCentres: "",
    vendor: "",
    saleChannel: "",
    mileage: "",
    capClean: "",
    colour: "",
    grade: "",
    mechanicalReport: "",
    age: "",
    plate: "",
    transmission: "",
    fuel: "",
    bodyType: "",
    engine: "",
    doors: "",
    vat: "",
    v5: "",
    fuelTypeHybrid: "",
    "condition-report": "",
  };

  // apply selections from previous filters to Search module
  previousFilters.forEach((item) => {
    const newValue = changeToAnalyticsFormat(item.filterKey);

    if (
      search[getAnalyticsAttribute[item.categoryKey]]?.length !== 0 &&
      !rangeFilters.indexOf(item.categoryKey)
    ) {
      const previousValue = search[getAnalyticsAttribute[item.categoryKey]];
      search[
        getAnalyticsAttribute[item.categoryKey]
      ] = `${previousValue},${newValue}`;
    } else {
      const previousValue = search[getAnalyticsAttribute[item.categoryKey]];
      if (previousValue === "") {
        search[getAnalyticsAttribute[item.categoryKey]] = `${newValue}`;
      } else {
        search[
          getAnalyticsAttribute[item.categoryKey]
        ] = `${previousValue},${newValue}`;
      }
    }
  });

  // apply selections from last selected filter to Search module
  if (allAppliedFilters?.length > 0) {
    Object.keys(lastAppliedFilter).forEach((item) => {
      search[item] = lastAppliedFilter[item];
    });
  }

  search["keyword"] = keyword || "";
  search["pagination"] = totalPages ? `${page || "1"}|${totalPages}` : "";
  search["sortBy"] = sortValue[sortBy] || "make";
  search["numResults"] = totalResults || "0";
  search["searchType"] =
    allAppliedFilters.length > 0
      ? "faceted-search"
      : Boolean(keyword)
      ? "free-text-search"
      : "";

  //== Transform to analytics format before push
  let transformDropdowns = ["age", "mileage", "capClean"];

  transformDropdowns.map((item: string) => {
    if (search[item] === "") {
      search[item] = changeToAnalyticsFormatDots(defaultValues[item]);
    } else {
      search[item] = changeToAnalyticsFormatDots(search[item]);
    }
  });

  if (search.saleDate !== "") {
    const dateField = search.saleDate;
    const dates = dateField.split(",");
    let result = [];

    dates.map((item) => {
      return result.push(date(item).format("yyyy-MM-DD"));
    });

    search.saleDate = result.toString();
  }

  if (search.narrative?.includes("battery-grade")) {
    search["batteryReport"] = "ev-graded";
  }

  // ====Grade Facet - Condition Report Checkbox:
  if (search["condition-report"] === "true") {
    search.grade.length > 0
      ? (search.grade += ",results-with-condition-report")
      : (search.grade += "results-with-condition-report");
  }
  if (search.narrative?.includes("condition-report")) {
    search.narrative = search.narrative.replace("condition-report", "grade");
  }
  if (search.filter?.includes("condition-report")) {
    search.filter = search.filter.replace("condition-report", "grade");
  }

  //===== Cap Clean Facet - awaiting-appraisal Checkbox:
  if (search["awaiting-appraisal"] === "false") {
    search.capClean += "";
  }
  if (search["capClean"]) {
    if (search["awaiting-appraisal"] === undefined) {
      search.capClean += "|vehicles-without-pricing-information";
    }
  }
  if (search.narrative?.includes("awaiting-appraisal")) {
    search.narrative = search.narrative.replace(
      "awaiting-appraisal",
      "capClean"
    );
  }
  if (search.filter?.includes("awaiting-appraisal")) {
    search.filter = search.filter.replace("awaiting-appraisal", "capClean");
  }

  //===== Mileage Facet 1 - warranted-mileage Checkbox:
  if (
    search["warranted-mileage"] === "true" ||
    (search["mileage"] && search["warranted-mileage"] !== undefined)
  ) {
    search.mileage += "|warranted";
  }
  if (search.narrative?.includes("warranted-mileage")) {
    search.narrative = search.narrative.replace("warranted-mileage", "mileage");
  }
  if (search.filter?.includes("warranted-mileage")) {
    search.filter = search.filter.replace("warranted-mileage", "mileage");
  }

  //  //===== Mileage Facet 2 - missing-mileage Checkbox:
  if (search["missing-mileage"] === "false") {
    search.mileage += "";
  }
  if (search["mileage"]) {
    if (search["missing-mileage"] === undefined) {
      search.mileage += "|unknown-mileage";
    }
  }
  if (search.narrative?.includes("missing-mileage")) {
    search.narrative = search.narrative.replace("missing-mileage", "mileage");
  }
  if (search.filter?.includes("missing-mileage")) {
    search.filter = search.filter.replace("missing-mileage", "mileage");
  }

  // Cleanup
  // Replace camelCase words with hyphen-words
  const mapObj = {
    capClean: "cap-clean",
    saleChannel: "sale-channel",
    auctionCentres: "auction-centres",
    modelGroup: "model-group",
    saleDate: "sale-date",
    searchType: "search-type",
    vehicleType: "vehicle-type",
    bodyType: "body-type",
    mechanicalReport: "mechanical-report",
  };

  // Narrative
  if (search.narrative) {
    search.narrative = search.narrative.replace(
      /\b(?:capClean|saleChannel|auctionCentres|modelGroup|saleDate|searchType|vehicleType|bodyType|mechanicalReport)\b/gi,
      (matched) => mapObj[matched]
    );
  }
  // Filter
  if (search.filter) {
    search.filter = search.filter.replace(
      /\b(?:capClean|saleChannel|auctionCentres|modelGroup|saleDate|searchType|vehicleType|bodyType|mechanicalReport)\b/gi,
      (matched) => mapObj[matched]
    );
  }

  // Remove Extra Keys from push object
  delete search["condition-report"];
  delete search["awaiting-appraisal"];
  delete search["missing-mileage"];
  delete search["warranted-mileage"];
  delete search["battery-grade"];

  // Narrative remove duplicates and reverse order
  if (search.narrative) {
    search.narrative = Array.from(new Set(search.narrative.split(",")))
      .reverse()
      .toString();
  }

  analytics.push<ISearchPushable>({
    event: {
      name: "search-pageview",
    },
    search,
  });
};

export default pushFilterAnalytics;
